import styled from 'styled-components';

import { Typography } from 'components/UI/Typography';
import { Colors } from 'environment';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 40rem;
`;

export const ReceipientsList = styled.div`
	width: 100%;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const ListHeader = styled(Typography.H5)`
	width: 100%;
	margin-bottom: 1rem;
	margin-top: 3rem;
`;

export const Receipient = styled.div`
	height: 6rem;
	display: flex;
	font-weight: 600;
	align-items: center;
	justify-content: space-between;
	padding-left: 1rem;
	border-bottom: 0.1rem solid ${Colors.gray.lightest};
`;

export const SvgWrapper = styled.div`
	height: 40rem;
	display: flex;
	align-items: center;
`;
